"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * A hook for controlling a single form field.
 *
 * @param initialValue The initial value of the input.
 * @param required    If `true`, the input will be considered invalid if dirty and empty.
 *
 * @returns Returns an object with the following properties:
 * `value`: The current value.
 * `onChange`: Callback to be fired when the input changes.
 * `isValid`: Boolean value indicating id the field value is valid.
 * `setValue`: Function which can be used to directly set the value.
 * `clear`: Function which can be used to clear the value and validation state.
 */
var useFormField = function (initialValue, required) {
    if (initialValue === void 0) { initialValue = ''; }
    if (required === void 0) { required = false; }
    var _a = __read(react_1.useState(initialValue), 2), value = _a[0], setValue = _a[1];
    var _b = __read(react_1.useState(''), 2), error = _b[0], setError = _b[1];
    var _c = __read(react_1.useState(true), 2), isValid = _c[0], setValid = _c[1];
    function onChange(e) {
        // Get the value from the change event
        setValue(e.target.value);
        // If the field is required but the value
        // is falsy, set isValid to false
        if (required && !e.target.value) {
            setValid(false);
        }
        else if (!isValid) {
            // If the field was invalid but now contains
            // a value, set is valid back to true
            setValid(true);
        }
    }
    // Clears the value and validation state
    function clear() {
        setValue('');
        setValid(true);
    }
    return {
        value: value || '',
        onChange: onChange,
        isValid: isValid,
        setValue: setValue,
        clear: clear,
        error: error,
        setError: setError,
    };
};
exports.default = useFormField;
//# sourceMappingURL=useFormField.js.map